import React from 'react';
import './index.css';
import util from "../../util/tools";
import cityData from "../../util/city";
import Toast from '../common/Toast'
import LoadMore from '../common/LoadMore'

export default class Home extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            toastText:'',
            multiArray: [cityData, [], []],
            data: {}
        };

        this.getInfoFun = this.getInfoFun.bind(this);
        this.xxdzFun = this.xxdzFun.bind(this);
        this.changeFun = this.changeFun.bind(this);
        this.saveFun = this.saveFun.bind(this);
    }

    componentDidMount() {
        document.title = '物流信息'
        this.getInfoFun();
    }

    getInfoFun(){
        util.ajax({
            // host: "http://open.fangkuai8.com",
            url: "/zh/sendgift/one",
            // app_key: "6821674987",
            // app_secret: "55f3b0e685b97de7e9c47ab3cd940vdn",
            isUser: true,
            data: {
                gift_id: this.props.match.params.giftid
            },
            callback: res => {
                if (res.result.status.code == 0) {
                    let tempData = this.state.multiArray;
                    if(!!res.result.data.province){
                        tempData[1] = tempData[0].filter(function(item){
                            return item.name == res.result.data.province;
                        })[0].city;
                    }
                    if(!!res.result.data.city){
                        tempData[2] = tempData[1].filter(function(item){
                            return item.name == res.result.data.city;
                        })[0].districtAndCounty;
                    }
                    this.setState({
                        data: res.result.data
                    })
                }
            }
        });
    }

    xxdzFun(e) {
      const curT = e.target;
      const name = curT.getAttribute("name");
      const userInfo = this.state.data;
      userInfo[name] = curT.value;
      this.setState({
        data: userInfo
      });
    }

    changeFun(e) {
        const curT = e.target,
            name = curT.getAttribute("name"),
            curIndex = curT.getAttribute("data-index");
        const userInfo = this.state.data;
        let multiArray = this.state.multiArray;
        userInfo[name] = curT.value;
        if (curIndex == 1) {
            // 省
            userInfo["city"] = "";
            userInfo["county"] = "";

            // multiArray[0] = cityData;
            multiArray[1] = multiArray[0].filter(function(item){
                return item.name == userInfo[name];
            })[0].city;
            multiArray[2] = [];
        } else if (curIndex == 2) {
            // 市
            userInfo["county"] = "";
            multiArray[2] = multiArray[1].filter(function(item){
                return item.name == userInfo[name];
            })[0].districtAndCounty;
        }
        this.setState({
            multiArray: multiArray,
            userInfo: userInfo
        });
    }

    saveFun(){
        util.ajax({
            // host: "http://open.fangkuai8.com",
            url: "/zh/sendgift/edit",
            // app_key: "6821674987",
            // app_secret: "55f3b0e685b97de7e9c47ab3cd940vdn",
            isUser: true,
            data: this.state.data,
            method: "POST",
            callback: res => {
                this.setState({
                    toastText: res.result.status.msg
                },()=>{
                    setTimeout(()=>{
                        this.setState({
                            toastText: ""
                        },()=>{
                            if (res.result.status.code == 0) {
                                try{
                                    window.history.back();
                                }catch(e){}
                            }
                        })
                    },2000);
                })
            }
        });
    }

    render() {
        let data = this.state.data;
        return (
            <div className='wuliuinfopage'>
                <div className='list'>
                    <div className='item' data-title="订单信息">{data.gift_name}</div>
                    <div className='item' data-title="订单编号">{data.order_no}</div>
                    <div className='item mt20' data-title="收货人">
                        <input
                            type="text"
                            onInput={this.xxdzFun}
                            className="txt1"
                            name="user_name"
                            value={data.user_name}
                        />
                    </div>
                    <div className='item' data-title="手机号码">
                        <input
                            type="text"
                            onInput={this.xxdzFun}
                            className="txt1"
                            name="phone"
                            value={data.phone}
                        />
                    </div>
                    <div className='item clearfix' data-title="所在地区">
                        <select
                            className="sel1"
                            data-index="1"
                            name="province"
                            onChange={this.changeFun}
                            value={data.province}
                        >
                            {!data.province && <option>请选择省份</option>}
                            {
                                this.state.multiArray[0].length > 0 &&
                                this.state.multiArray[0].map((item, index) => (
                                    <option
                                        key={`a${index}`}
                                        value={`${item.name}`}
                                    >{item.name}</option>
                                ))
                            }
                        </select>
                        <select
                            className="sel1"
                            data-index="2"
                            name="city"
                            onChange={this.changeFun}
                            value={data.city}
                        >
                            {!data.city_info && <option>请选择城市</option>}
                            {this.state.multiArray[1].length > 0 &&
                            this.state.multiArray[1].map((item, index) => (
                                <option
                                    key={`b${index}`}
                                    value={`${item.name}`}
                                >{item.name}</option>
                            ))}
                        </select>
                        <select
                            className="sel1"
                            data-index="3"
                            name="county"
                            onChange={this.changeFun}
                            value={data.county}
                        >
                            {!data.county && (
                            <option>请选择地区</option>
                            )}
                            {this.state.multiArray[2].length > 0 &&
                            this.state.multiArray[2].map((item, index) => (
                                <option
                                    key={`c${index}`}
                                    value={`${item}`}
                                >{item}</option>
                            ))}
                        </select>
                    </div>
                    <div className='item' data-title="详细地址">
                        <textarea
                            type="text"
                            onInput={this.xxdzFun}
                            className="txt2"
                            name="address"
                            value={data.address}
                        ></textarea>
                    </div>
                </div>
                <div className='saveBtn' onClick={this.saveFun}>保存</div>
                <div className='tipBox'>
                    <div className='title'>温馨提示</div>
                    <div className='tip'>基于快递公司的配送要求，有些地域，可能需要中转或不 能送达，包括新疆、西藏、青海、甘肃等地的部分区域…</div>
                    <div className='tip'>活动咨询客服电话：400-0265-859</div>
                    <div className='tip'>配送专用客服电话：400-0265-365</div>
                    <div className='tip'>工作时间：9: 00 - 18: 00</div>
                </div>
                <Toast text={this.state.toastText}/>
            </div>
        );
    }
}